import { render } from "./ProfileNFTsV1.1.vue?vue&type=template&id=71b129a4&scoped=true"
import script from "./ProfileNFTsV1.1.vue?vue&type=script&lang=js"
export * from "./ProfileNFTsV1.1.vue?vue&type=script&lang=js"

import "./ProfileNFTsV1.1.vue?vue&type=style&index=0&id=71b129a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b129a4"]])

export default __exports__